export enum ParameterType {
	// See app-shell\libs\management-portal\shared\src\lib\connected-app\parameter-type.enum.ts
	// for the rest.
	Dropdown = 6,
	Boolean = 7,
}
